import { TweenLite } from 'gsap/all'
import { debounce } from './_helpers'

export default function simpleDropdown(page, eventListenersRemover) {
  page.querySelectorAll('[data-simple-dropdown]').forEach(el => {
    const clickArea = el.querySelector('[data-click-area]')
    const dropdownList = el.querySelector('[data-list]')
    const getListHeight = list =>
      Array.from(list.children).reduce((acc, cur) => acc + cur.clientHeight, 0)
    const setListHeight = () => {
      if (el.classList.contains('open')) {
        TweenLite.set(dropdownList, {
          height: getListHeight(dropdownList),
        })
      }
    }
    const debouncedSetListHeight = debounce((list, mutationObserver) => {
      setListHeight()
      mutationObserver.disconnect()
    }, 500)

    TweenLite.set(dropdownList, {
      pointerEvents: 'none',
      height: 0,
      opacity: 0,
    })

    clickArea.addEventListener('click', () => {
      el.classList.toggle('open', !el.classList.contains('open'))

      if (el.classList.contains('open')) {
        TweenLite.to(dropdownList, {
          duration: 0.3,
          height: getListHeight(dropdownList),
          opacity: 1,
          pointerEvents: 'auto',
        })
      } else {
        TweenLite.to(dropdownList, {
          duration: 0.3,
          height: 0,
          opacity: 0,
          pointerEvents: 'none',
        })
      }
    })

    const mutationObserver = new MutationObserver(mutations =>
      mutations.forEach(() => {
        debouncedSetListHeight(dropdownList, mutationObserver)
      })
    )

    mutationObserver.observe(dropdownList, {
      childList: true,
      subtree: true,
    })

    window.addEventListener('resize', setListHeight)

    eventListenersRemover.push({
      el: window,
      event: 'resize',
      func: setListHeight,
    })
  })
}
